import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpEvent,
  HttpHeaders,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Files, FileType } from '../models/files.model';

@Injectable({
  providedIn: 'root',
})
export class FilesService {
  private apiServerUrl = environment.loganConfig.url;
  constructor(private http: HttpClient) {}
  headers = new HttpHeaders().set('Content-Type', 'multipart/form-data');
  requestOptions: Object = {
    headers: this.headers,
    reportProgress: true,
    responseType: 'json',
  };

  public createFileInfo(file: Files): Observable<any> {
    return this.http.post<Files>(
      `${this.apiServerUrl}/files/createFileInfo`,
      file
    );
  }

  fileUpload(file: File, fileId: number): Observable<HttpEvent<any>> {
    const formData: FormData = new FormData();

    formData.append('file', file);

    const req = new HttpRequest(
      'POST',
      `${this.apiServerUrl}/files/uploadFile/${fileId}`,
      formData,
      {
        reportProgress: true,
        responseType: 'json',
        withCredentials: true,
      }
    );

    return this.http.request(req);
  }

  public getFiles(fileTypeId: number): Observable<Files[]> {
    return this.http.get<Files[]>(
      `${this.apiServerUrl}/files/getFiles/${fileTypeId}`
    );
  }

  public getFilesType(): Observable<FileType[]> {
    return this.http.get<FileType[]>(`${this.apiServerUrl}/files/getFilesType`);
  }

  public downloadFile(fileId: number) {
    window.open(this.apiServerUrl + '/files/downloadFile/' + fileId);
  }

  public inactiveFile(fileId: number) {
    return this.http.get<FileType[]>(
      `${this.apiServerUrl}/files/inactiveFile/` + fileId
    );
  }
  public changeProductionFlagFile(fileId: number, isProduction: string) {
    return this.http.get<FileType[]>(
      `${this.apiServerUrl}/files/changeProductionFlagFile/` +
        fileId +
        '/' +
        isProduction
    );
  }
  public getStatusOTA(
    seriais: string[],
    statusOTAManufactor: string
  ): Observable<any> {
    return this.http.post<any>(
      `${this.apiServerUrl}/files/getStatusOTA/${statusOTAManufactor}`,
      seriais,
      { withCredentials: true }
    );
  }
}
